import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatTime', pure: true })
export class FormatTimePipe implements PipeTransform {
  public transform(milliseconds: number, postfix = 'left'): string {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    const weeks = Math.floor(days / 7);
    const remainingDays = days % 7;

    if (weeks > 0) {
      return `${weeks} week${this.getPluralSuffix(weeks)}, ${remainingDays} day${this.getPluralSuffix(remainingDays)} ${postfix}`;
    } else if (days > 0) {
      return `${days} day${this.getPluralSuffix(days)}, ${remainingHours} hour${this.getPluralSuffix(remainingHours)} ${postfix}`;
    } else if (hours > 0) {
      return `${hours} hour${this.getPluralSuffix(hours)}, ${remainingMinutes} minute${this.getPluralSuffix(remainingMinutes)} ${postfix}`;
    } else if (minutes > 0) {
      return `${minutes} minute${this.getPluralSuffix(minutes)} ${postfix}`;
    } else if (seconds > 0) {
      return `${remainingSeconds} second${this.getPluralSuffix(seconds)} ${postfix}`;
    } else {
      return '';
    }
  }

  private getPluralSuffix(units: number): string {
    return units > 1 ? 's' : '';
  }
}
